<section class="tw-h-full runner-section">
  <!-- Runner section, and Race is not final -->
  <!-- (scroll)="onScrollHideBetPreview()"  -->
  <div
    #runnerRef [hidden]="selectedRace?.RaceStatus === 3" class="tw-overflow-y-auto">
    <div
      #wagingSectionTemplateRef
      class="waging-section tw-flex"
      *ngIf="isShowRunnners"
    >

      <!-- Left side -->
      <div class="runner-container" data-cy="runner-container">

        <!-- Display selection -->
        <div class="info-replays tw-flex tw-pl-[15px]">
          <ion-button class="tw-w-[100px]" data-cy="wager-info-button">
            INFO
          </ion-button>
          <ion-button class="tw-w-[100px]" (click)="replayVideo()" data-cy="wager-replays-button">
            REPLAYS
          </ion-button>
        </div>

        <!-- Runner table -->
        <div class="current-races tw-w-[100%] tw-mt-[12px]" data-cy="runner-table">
          <!-- Header -->
          <div class="head-runner">
            <span class="tw-uppercase tw-pb-[10.5px]">pos</span>
            <span class="tw-uppercase tw-pb-[10.5px]">runner info</span>
            <span class="tw-uppercase tw-text-left tw-pb-[10.5px] tw-pl-[3px]">odds</span>
          </div>

          <!-- Body content -->
          <div *ngIf="!dblPkArray" class="table-runner runners-section">
            <div class="content-runner">

              <ng-container *ngIf="!selectedRace?.Runners?.[0]?.Entries">
                <p class="tw-p-2">
                  No Entries Available
                </p>
              </ng-container>

              <ng-container *ngIf="selectedRace?.Runners?.[0]?.Entries">
                <div
                  #currentEntries
                  *ngFor="let runner of selectedRace?.Runners; index as indexRunner; "
                  class="!tw-block runner-info runner-id-{{runner.RunnerId}}"
                  [attr.data-cy]="'runner-info-' + runner.RunnerId"
                  amwager3LegHeight
                  [amwager3LegHeightRunnerId]="runner.RunnerId"
                  [amwager3LegHeightEntries]="runner.Entries"
                  data-cy="runner-row"
                >
                  <div
                    *ngFor="let runnerEntry of runner?.Entries; let i = index"
                    class="runner-group runner-ui-{{runner.RunnerId}}-{{i+1}} tw-w-full"
                    [attr.data-cy]="'runner-entry-' + i"
                  >
                    <div class="pos tw-text-center {{ (selectedEvent?.ToteResponse?.EventDetail?.TrackType| getTrackType: true)+'-'+runner?.RunnerId }}"
                      [attr.data-cy]="'runner-position-' + runner.RunnerId + '-' + i">
                      {{ i > 0 ? runner.RunnerId + runnerEntry?.EntryId : runner.RunnerId }}
                    </div>
                    <div class="runner tw-p-[5px]">
                      <div class="tw-flex tw-items-center">
                        <!-- <img src="assets/icons/{{runner.RunnerId}}suit_icon.png" alt="suit icon"/> -->
                        <img
                          [src]="
                            selectedEvent?.ToteResponse?.EventDetail?.TrackType | getTrackIcon:
                            'assets/icons/suit_light_icon.png':
                            'assets/icons/greyhound_light_icon.png':
                            'assets/icons/harness_light_icon.png'
                          "
                          class="l-mode"
                          alt="track icon"
                          [attr.data-cy]="'runner-light-img-' + runner.RunnerId + '-' + i"
                        />
                        <img
                          [src]="
                            selectedEvent?.ToteResponse?.EventDetail?.TrackType | getTrackIcon:
                            'assets/icons/suit_dark_icon.png':
                            'assets/icons/greyhound_dark_icon.png':
                            'assets/icons/harness_dark_icon.png'
                          "
                          class="d-mode"
                          alt="track icon"
                          [attr.data-cy]="'runner-dark-img-' + runner.RunnerId + '-' + i"
                        />
                        <p class="tw-inline-block">
                          <span
                            class="entry-name tw-font-bold"
                            [class.tw-line-through]="runnerEntry?.Scratch"
                            [attr.data-cy]="'runner-name-' + runner.RunnerId + '-' + i"
                          >
                            {{ runnerEntry.Name }}
                          </span>

                          <ion-icon
                            (click)="showRunnerInfo($event, runnerEntry)" class="show-info-popover"
                            name="information-circle-outline"
                            [attr.data-cy]="'runner-more-info-' + runner.RunnerId + '-' + i">
                          </ion-icon>

                          <!-- <ion-popover trigger="show-info-{{runner.RunnerId}}-{{i}}" triggerAction="click">
                            <ng-template >
                              <p class="tw-p-2">
                                <span [attr.data-cy]="'runner-trainer-' + runner.RunnerId">
                                  {{ runnerEntry.Trainer }}, {{ runnerEntry.Weight | horseWeight }}
                                </span>
                                <br>
                                <span [attr.data-cy]="'runner-jockey-' + runner.RunnerId">
                                  {{ runnerEntry.Jockey }}
                                </span>
                              </p>
                            </ng-template>
                          </ion-popover> -->

                          <!-- <br>
                          <span [attr.data-cy]="'runner-trainer-' + runner.RunnerId">{{ runnerEntry.Trainer }}, {{ runnerEntry.Weight | horseWeight }}</span> <br>
                          <span [attr.data-cy]="'runner-jockey-' + runner.RunnerId">{{ runnerEntry.Jockey }}</span> -->
                        </p>
                      </div>
                    </div>
                    <div class="odds tw-p-[5px]">
                      <p class="tw-font-bold" [attr.data-cy]="'runner-ml-' + runner.RunnerId + '-' + i">
                        ML:
                        {{
                          (runnerEntry?.Scratch) ?
                            '-'
                          :
                            runner.Odds || '-'
                        }}
                      </p>
                      <!-- <br> -->
                      <p
                        class="tw-font-bold"
                        [class.tw-line-through]="runnerEntry?.Scratch"
                        [attr.data-cy]="'runner-odds-' + runner.RunnerId + '-' + i"
                      >
                        ODDS:
                        {{
                          (runnerEntry?.Scratch) ?
                            'SCR'
                              :
                            !selectedRace.Current ?
                              '-'
                                :
                              ((matrix || null) | matrixData: indexRunner: 'odd') || '-'
                        }}
                      </p>
                    </div>
                  </div>

                </div>
              </ng-container>

            </div>
          </div>

          <div *ngIf="dblPkArray" class="table-runner runners-section">
            <div class="content-runner">

              <!-- <ng-container *ngIf="!selectedRace.Runners[0]?.Entries">
                <p class="tw-p-2">
                  No Entries Available
                </p>
              </ng-container> -->

              <!-- <ng-container *ngIf="selectedRace.Runners[0]?.Entries"> -->
                <!-- #runnerInfo -->
                <ng-container *ngFor="let race of dblPkArray; ">
                  <ng-container *ngIf="race.RaceId === showCurrentInfo">
                  <div
                    *ngFor="let runner of race?.Runners; index as indexRunner"
                    class="!tw-block runner-info runner-id-{{runner.RunnerId}}"
                    [attr.data-cy]="'runner-info-' + runner.RunnerId"
                    amwager3LegHeight
                    [amwager3LegHeightRunnerId]="runner.RunnerId"
                    [amwager3LegHeightEntries]="runner.Entries"
                  >

                    <ng-container *ngIf="runner.toHide">
                      <div
                        #runnerInfo
                        id="runner-info"
                        class="runner-info tw-h-[60px]"
                      >
                      </div>
                    </ng-container>

                    <ng-container *ngIf="!runner.toHide" #currentEntries>
                      <div
                        #runnerInfo
                        *ngFor="let runnerEntry of runner?.Entries; index as i; "
                        class="runner-group runner-ui-{{runner.RunnerId}}-{{i+1}} tw-w-full"
                        [attr.data-cy]="'runner-entry-' + runner.RunnerId + '-' + (i+1)"
                      >
                        <div class="pos tw-text-center {{ (selectedEvent?.ToteResponse?.EventDetail?.TrackType| getTrackType: true)+'-'+runner?.RunnerId }}"
                          [attr.data-cy]="'runner-position-' + runner.RunnerId">
                          <ng-container *ngIf="!runnerEntry.toHide">
                            {{ i > 0 ? runner.RunnerId + runnerEntry?.EntryId : runner.RunnerId }}
                          </ng-container>
                        </div>
                        <div class="runner tw-p-[5px]">
                          <div *ngIf="!runnerEntry.toHide && !runnerEntry.isReplica" class="tw-flex tw-items-center">
                            <!-- <img src="assets/icons/{{runner.RunnerId}}suit_icon.png" alt="suit icon"/> -->
                            <!-- [class.tw-invisible]="
                              selectedEvent?.ToteResponse?.EventDetail?.TrackType === 2 ||
                              selectedEvent?.ToteResponse?.EventDetail?.TrackType === 4
                            " -->
                            <img
                              [src]="
                                selectedEvent?.ToteResponse?.EventDetail?.TrackType | getTrackIcon:
                                'assets/icons/suit_light_icon.png':
                                'assets/icons/greyhound_light_icon.png':
                                'assets/icons/harness_light_icon.png'
                              "
                              class="l-mode"
                              alt="track icon"
                            />
                            <img
                              [src]="
                                selectedEvent?.ToteResponse?.EventDetail?.TrackType | getTrackIcon:
                                'assets/icons/suit_dark_icon.png':
                                'assets/icons/greyhound_dark_icon.png':
                                'assets/icons/harness_dark_icon.png'
                              "
                              class="d-mode"
                              alt="track icon"
                            />
                            <p class="tw-inline-block">
                              <span
                                class="entry-name tw-font-bold"
                                [class.tw-line-through]="runnerEntry?.Scratch"
                                [attr.data-cy]="'runner-name-' + runner.RunnerId"
                              >
                                {{ runnerEntry.Name }}
                              </span>

                              <ion-icon
                                (click)="showRunnerInfo($event, runnerEntry)" class="show-info-popover"
                                name="information-circle-outline">
                              </ion-icon>

                              <!-- <br>
                              <span [attr.data-cy]="'runner-trainer-' + runner.RunnerId">{{ runnerEntry.Trainer }}, {{ runnerEntry.Weight | horseWeight }}</span> <br>
                              <span [attr.data-cy]="'runner-jockey-' + runner.RunnerId">{{ runnerEntry.Jockey }}</span> -->
                            </p>
                          </div>
                        </div>
                        <div class="odds tw-p-[5px]">
                          <p *ngIf="!runnerEntry.toHide && !runnerEntry.isReplica" class="tw-font-bold" [attr.data-cy]="'runner-ml-' + runner.RunnerId">
                            ML:
                            {{
                              (runnerEntry?.Scratch) ?
                                '-'
                              :
                                runner.Odds || '-'
                            }}
                          </p>
                          <!-- <br> -->
                          <p
                            *ngIf="!runnerEntry.toHide && !runnerEntry.isReplica"
                            class="tw-font-bold"
                            [class.tw-line-through]="runnerEntry?.Scratch"
                            [attr.data-cy]="'runner-odds-' + runner.RunnerId"
                          >
                            ODDS:
                            {{
                              (runnerEntry?.Scratch) ?
                                'SCR'
                                  :
                                !race.Current ?
                                  '-'
                                    :
                                  ((matrix || null) | matrixData: indexRunner: 'odd') || '-'
                            }}
                          </p>
                        </div>
                      </div>
                    </ng-container>

                  </div>
                  </ng-container>
                </ng-container>
              <!-- </ng-container> -->

            </div>
          </div>

        </div>
      </div>

      <!-- Right side, Leg section -->
      <div
        *ngIf="!dblPkArray"
        [ngClass]="{'empty-pool': selectedPool === undefined}"
        class="swipe-container tw-w-[100%] tw-pt-[5px]"
        data-cy="legs-container"
      >

        <!-- Header -->
        <div class="mode-place-races tw-flex tw-w-[100%]">
          <!-- *ngFor="let leg of (selectedPool?.Legs||0 | convertTRange)" -->
          <div
            class="head-bet tw-text-center tw-pb-[10.5px]"
            *ngFor="let leg of convertLegRange(
              selectedPool?.Legs,
              selectedPool?.PoolId,
              selectedModifier
            ); "
          >
            <span
              (click)="betAllRace($event, leg)"
              id="{{leg}}"
              class="mode selector-leg-all-{{leg}}"
              data-cy="wager-all"
            >
              ALL
            </span>
            <span class="place" data-cy="wager-legs">
              {{ leg | ordinals }}
            </span>
          </div>
        </div>

        <!-- Body, leg where to bet a runner -->
        <div class="table-bet race-legs-section">
          <div class="content-bet">
            <div
              #currentRunners
              [id]="runner?.RunnerId"
              class="bet leg-id-{{runner.RunnerId}} tw-flex-col"
              *ngFor="let runner of selectedRace?.Runners; "
            >
              <div
                class="leg-ui-{{runner.RunnerId}}-{{i+1}} bet-content tw-flex"
                *ngFor="let runnerEntry of runner?.Entries; index as i; "
                [attr.data-cy]="'runners-' + i + '-' + runner.RunnerId"
              >
                <ng-container *ngIf="runnerEntry?.Scratch">
                  <span
                    *ngFor="let leg of convertLegRange(
                      selectedPool?.Legs,
                      selectedPool?.PoolId,
                      selectedModifier
                    ); "
                    class="scratch tw-uppercase tw-font-bold tw-text-[12px]"
                    [attr.data-cy]="'runner-scratch-' + runner.RunnerId"
                  >
                    scr
                  </span>
                </ng-container>
                <ng-container *ngIf="!runnerEntry?.Scratch">
                  <!-- *ngFor="let leg of (selectedPool?.Legs||0 | convertTRange)convertTRange" -->
                  <i
                    (click)="betRace($event, selectedPool.PoolId, runner?.RunnerId, 0, leg)"
                    *ngFor="let leg of convertLegRange(
                      selectedPool?.Legs,
                      selectedPool?.PoolId,
                      selectedModifier
                    ); "
                    class="runner-{{runner?.RunnerId}} leg-{{leg}}"
                    [ngClass]="{'sub-couple-entry': i > 0}"
                    [attr.data-cy]="'select-runner-' + leg + '-' + runner.RunnerId"
                    [attr.data-entry-id]="runnerEntry?.EntryId"
                    id="{{leg}}"
                  ></i>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="dblPkArray"
        [ngClass]="{'empty-pool': selectedPool === undefined}"
        id="dblPkList-container"
        class="swipe-container tw-w-[100%] tw-pt-[5px]"
      >

        <!-- Header -->
        <div class="mode-place-races tw-flex tw-w-[100%]">
          <!-- *ngFor="let leg of (selectedPool?.Legs||0 | convertTRange)" -->
          <div
            class="head-bet tw-text-center tw-pb-[9.5px]"
            *ngFor="let item of dblPkArray; "
          >
            <span
              *ngIf="item.RaceId"
              (click)="betAllRace($event, item.RaceId)"
              id="{{item.RaceId}}"
              class="mode selector-leg-all-{{item.RaceId}}"
              data-cy="wager-all"
            >
              ALL
            </span>
            <span
              *ngIf="item.RaceId"
              (click)="showCurrentInfoByRace($event, item.RaceId)"
              id="race"
              class="place"
              data-cy="wager-legs"
            >
              R{{ item.RaceId }}
            </span>
          </div>
        </div>

        <!-- Body, leg where to bet a runner -->
        <div class="table-bet dblPkList race-legs-section">
          <div
            #currentRunners
            *ngFor="let item of dblPkArray;"
            class="content-bet"
          >

            <ng-container >
              <!-- tw-flex-col -->
              <!-- #legsInfo -->
              <div
                [id]="runner?.RunnerId"
                class="bet leg-id-{{runner.RunnerId}}"
                *ngFor="let runner of item?.Runners; "
              >
                <!-- tw-flex -->
                <!-- <div
                  *ngIf="runner?.Scratch"
                  class="bet-content"
                >
                  <span class="scratch tw-uppercase tw-font-bold tw-text-[12px]">scr</span>
                </div> -->

                <div
                  #legsInfo
                  *ngIf="runner.toHide"
                  class="bet-content"
                >
                </div>

                <ng-container *ngIf="!runner.toHide">
                  <div
                    #legsInfo
                    class="leg-ui-{{runner.RunnerId}}-{{i+1}} bet-content"
                    *ngFor="let runnerEntry of runner?.Entries; index as i; "
                    [attr.data-cy]="'runners-' + i + '-' + runner.RunnerId"
                  >

                    <ng-container
                      *ngIf="runnerEntry?.Scratch"
                    >
                      <span class="scratch tw-uppercase tw-font-bold tw-text-[12px]">scr</span>
                    </ng-container>

                    <ng-container *ngIf="!runnerEntry?.Scratch && !runnerEntry.toHide && !runnerEntry.isReplica">
                      <!-- *ngFor="let leg of (selectedPool?.Legs||0 | convertTRange)convertTRange" -->
                      <i
                        (click)="betRace(
                          $event, selectedPool.PoolId, runner?.RunnerId, item.RaceId, item.RaceId
                        )"
                        class="runner-{{runner?.RunnerId}} leg-{{item.RaceId}}"
                        [ngClass]="{'sub-couple-entry': i > 0}"
                        [attr.data-cy]="'select-runner-' + (item.RaceId) + '-' + runner.RunnerId"
                        [attr.data-entry-id]="runnerEntry?.EntryId"
                        [attr.data-index-is]="i"
                        id="{{item.RaceId}}"
                      ></i>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>

          </div>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="isShowBetPreview"
    class="bet-footer-section tw-w-full tw-pt-[9px] tw-pb-[10px]"
    data-cy="bet-preview-section"
  >
    <ion-icon (click)="closeBet()" name="close-outline" class="close-bet" data-cy="close-bet-preview"></ion-icon>
    <div class="event-info" data-cy="bet-preview-info">

      <p
        *ngIf="dutchAbcErrorMsg"
        class="bet-err-msg tw-text-left tw-text-[#951D1D] tw-pr-[15px] tw-pl-[15px]"
      >
        {{dutchAbcErrorMsg}}
      </p>
      <p
        *ngIf="cantBet"
        class="bet-err-msg cant-bet tw-text-left tw-text-[#951D1D] tw-pr-[15px] tw-pl-[15px]"
        data-cy="cant-bet-message"
      >
        No valid wager possible
      </p>
      <p class="amount-info bet-err-msg tw-text-left tw-text-[16px] tw-pr-[15px] tw-pl-[15px]">

        <ng-container *ngIf="selectedModifier.toLowerCase() === 'dutchcost' && dutchTicket">
          {{
            dutchTicket.calcAmount() > balanceAmount ?
              'Total $'+(dutchTicket.calcAmount() | number:'1.2')
              +' greater than current balance of $'+(balanceAmount | number:'1.2')
            :
              ''
          }}
        </ng-container>

        <ng-container *ngIf="selectedModifier.toLowerCase() === 'abc'">
          {{
            abcTotalAmount > balanceAmount ?
              'Total $'+(abcTotalAmount | number:'1.2')
              +' greater than current balance of $'+(balanceAmount | number:'1.2')
            :
              ''
          }}
        </ng-container>

        <ng-container
          *ngIf="
            selectedModifier.toLowerCase() !== 'abc' &&
            selectedModifier.toLowerCase() !== 'dutchcost'
          "
        >

          {{
            this.betTotal() > this.selectedPool.WBMaximum ?
              'Total ' +
              this.betTotal() +
              ' greater than maximum wager of ' +
              this.selectedPool.WBMaximum
            :
              betTotal() > balanceAmount ?
                'Total $'+(betTotal() | number:'1.2')
                +' greater than current balance of $'+(balanceAmount | number:'1.2')
              :
                ''
          }}

          <!-- {{
            betTotal() > balanceAmount ?
              'Total $'+(betTotal() | number:'1.2')
              +' greater than current balance of $'+(balanceAmount | number:'1.2')
            :
              (
                this.betTotal() > this.selectedPool.WBMaximum ||
                this.betTotal() < this.selectedPool.WagerMinimum
              ) ?
                this.betTotal() > this.selectedPool.WBMaximum ?
                  'Total ' +
                  this.betTotal() +
                  ' greater than maximum wager of ' +
                  this.selectedPool.WBMaximum
                :
                  'Amount ' +
                  this.betTotal() +
                  ' less than minimum of ' +
                  this.selectedPool.WagerMinimum
                  :
                ''
          }} -->
        </ng-container>
      </p>

      <p class="tw-text-left tw-text-[20px] tw-font-bold tw-pr-[15px] tw-pl-[15px]">
        <span data-cy="bet-preview-amount">
          <!-- ${{ baseAmount | formatAmount }} -->
          <ng-container *ngIf="selectedModifier.toLowerCase() === 'dutchcost' && dutchTicket">
            {{
              '$'+(dutchTicket.calcAmount() | number:'1.2')
            }}
          </ng-container>

          <ng-container *ngIf="selectedModifier.toLowerCase() === 'abc'">
            {{
              '$'+(abcTotalAmount | number:'1.2')
            }}
          </ng-container>

          <ng-container
            *ngIf="
              selectedModifier.toLowerCase() !== 'abc' &&
              selectedModifier.toLowerCase() !== 'dutchcost'
            "
          >
            {{
              '$'+(baseAmount | formatAmount)
            }}
          </ng-container>
        </span>
        <span data-cy="bet-preview-pool">
          {{ selectedPool !== undefined ? selectedPool.PoolId : '' }}
        </span>
        <!-- {{ selectedEvent !== undefined ? selectedEvent.ToteResponse.EventDetail.EventId : '' }} -->
        <span data-cy="bet-preview-modifier">
          {{
            selectedModifier !== undefined ?
            selectedModifier === 'DutchCost' ?
              'DC' : selectedModifier : ''
          }}
        </span>
        on
        <span data-cy="bet-preview-runners">{{storedSelectedRunners}} </span>
        <span class="dutch-roi">{{dutchROI}} </span>
        <!-- *ngIf="!dblPkArray" -->
        <span data-cy="bet-preview-race" class="race">
          R {{ selectedRace !== undefined ? selectedRace.RaceId : '' }}
        </span>
        <!-- MTP - 2 -->
      </p>
    </div>

    <div class="select-column tw-text-center">
      <p class="bet-amount tw-font-bold tw-text-[16px]" data-cy="bet-preview-total">
        <ng-container *ngIf="selectedModifier.toLowerCase() === 'dutchcost' && dutchTicket">
          {{
            'Total : $'+((
              dutchTicket.calcAmount() > 0 ? dutchTicket.calcAmount() : 0
            ) | number:'1.2')
          }}
        </ng-container>

        <ng-container *ngIf="selectedModifier.toLowerCase() === 'abc'">
          {{
            'Total : $'+((abcTotalAmount > 0 ? abcTotalAmount : 0) | number:'1.2')
          }}
        </ng-container>

        <ng-container
          *ngIf="
            selectedModifier.toLowerCase() !== 'abc' &&
            selectedModifier.toLowerCase() !== 'dutchcost'
          "
        >
          {{
            'Total : $'+((betTotal() > 0 ? betTotal() : 0) | number:'1.2')
          }}
        </ng-container>
      </p>
    </div>

    <div class="button-column tw-text-center">
      <!-- || dutchAbcErrorMsg  -->
      <ion-button
        (click)="confirmBet('save-bet')"
        [disabled]="
          cantBet ||
          isProcessingBet ||
          (
            selectedModifier.toLowerCase() === 'dutchcost' &&
            !dutchTotalAmount
          ) ||
          (
            selectedModifier.toLowerCase() === 'abc' &&
            !abcTotalAmount
          ) ||
          (
            (
              selectedModifier.toLowerCase() !== 'dutchcost' &&
              selectedModifier.toLowerCase() !== 'abc'
            ) &&
            this.betTotal() > this.selectedPool.WBMaximum ||
            this.betTotal() < this.selectedPool.WagerMinimum
          )
        "
        class="save-bet tw-uppercase"
        data-cy="save-bet"
      >
        save bet
      </ion-button>
      <ion-button
        (click)="confirmBet('bet-now')"
        [disabled]="
          cantBet ||
          isProcessingBet ||
          (
            selectedModifier.toLowerCase() === 'dutchcost' &&
            !dutchTotalAmount
          ) ||
          (
            selectedModifier.toLowerCase() === 'abc' &&
            !abcTotalAmount
          ) ||
          (
            (
              selectedModifier.toLowerCase() !== 'dutchcost' &&
              selectedModifier.toLowerCase() !== 'abc'
            ) &&
            this.betTotal() > this.selectedPool.WBMaximum ||
            this.betTotal() < this.selectedPool.WagerMinimum
          )
        "
        class="tw-uppercase"
        data-cy="bet-amount-bet-now"
      >
        bet now
      </ion-button>
    </div>
  </div>

</section>
